import { safeSessionStorage } from '@ifixit/utils';

const getWorkOrder = () => safeSessionStorage.getItem('thd_workorder');

const getWorkOrderIncident = () => safeSessionStorage.getItem('thd_workorder_incident');

export { getWorkOrder, getWorkOrderIncident };
